// Fanger render-feil, viser feilen og rapporterer den til backend.
//
// Brukes to steder: ytterst i App (alt, også TV-skjermene og kundesidene) og
// rundt siden i DashboardLayout, med ruta som nøkkel. Før var den bare
// ytterst, så en feil på én side tok med seg menyen, og man kom ikke videre
// uten å laste inn på nytt. Nå står menyen, og et sidebytte nullstiller feilen.
//
// Stilen er inline (ikke Tailwind-variabler), så den virker også på
// TV-skjermene med gamle nettlesere.
import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null } }
  static getDerivedStateFromError(error) { return { error } }
  componentDidCatch(error, errorInfo) {
    // Rapporter render-feil til backend slik at vi får dem inn uten å
    // be operatør om skjermbilde av stacken (kjipt på TV-er som
    // Raspberry Pi). Samme endepunkt som TV-en bruker for boot-errors.
    // Best-effort: ignorer fetch-feil — hvis backenden er ute kan vi
    // ikke gjøre noe uansett, og vi vil ikke kaskadere errors.
    try {
      fetch('/api/screens/_error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          kind: 'react-render-error',
          message: String(error?.message || error || ''),
          stack: String(error?.stack || ''),
          componentStack: String(errorInfo?.componentStack || ''),
          url: typeof window !== 'undefined' ? window.location.href : '',
          ua: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        }),
      }).catch(() => { /* swallow */ })
    } catch { /* ignore */ }
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, color: '#ff6b6b', fontFamily: 'monospace' }}>
          <h2>Render Error</h2>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{this.state.error.message}</pre>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 11, opacity: 0.7 }}>{this.state.error.stack}</pre>
          <button onClick={() => this.setState({ error: null })} style={{ marginTop: 16, padding: '8px 16px', cursor: 'pointer' }}>Prøv igjen</button>
        </div>
      )
    }
    return this.props.children
  }
}
